module.exports = __webpack_public_path__ + "img/weddings_15_V.1536aeed.webp";